export const getPreferredLastName = ({
  firstName,
  lastName = '',
  nickName,
}: {
  firstName: string;
  lastName?: string;
  nickName?: string | null;
}) => {
  if (nickName) return `${lastName}, ${firstName} (${nickName})`.trim();

  return `${lastName}, ${firstName}`.trim();
};
